export default __webpack_public_path__ + "static/media/background_placeholder.ded1db84.jpg";